import { render, staticRenderFns } from "./SectionTextGallery.vue?vue&type=template&id=7c01f428&scoped=true&"
import script from "./SectionTextGallery.vue?vue&type=script&lang=js&"
export * from "./SectionTextGallery.vue?vue&type=script&lang=js&"
import style0 from "./SectionTextGallery.vue?vue&type=style&index=0&id=7c01f428&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c01f428",
  null
  
)

export default component.exports